// import { CreateDrawer } from "../../components/drawer/DrawerComponent";
// import { sAddCustomer } from "../../constants/strings";
// import { UserForm } from "../../forms/UserForm";
import { UserRegister } from "./UserRegister";

export const Customers = () => {
  return (
    <div>
      {/* <CreateDrawer title={sAddCustomer} form={<UserForm />} /> */}
      <h3>Customers Register</h3>
      <UserRegister />
    </div>
  );
};
